import { useRxData } from 'rxdb-hooks';
import { RxCollection, RxDocument } from 'rxdb';
import { useCallback } from 'react';
import { useRxCountQuery } from '@hooks/useCount';

export type IUseDataReturn<T> = {
	result: RxDocument<T>[];
	isFetching: boolean;
	fetchMore: () => void;
	totalCount?: number;
};

export const useGetRxDb = <T,>(name = ''): IUseDataReturn<T> => {
	const queryConstructor = useCallback((collection: RxCollection<T>) => collection.find(), []);

	const { result, isFetching, fetchMore } = useRxData<T>(name, queryConstructor);

	const totalCount = useRxCountQuery<T>(name, queryConstructor);

	return {
		result,
		isFetching,
		fetchMore,
		totalCount,
	};
};
